import React, { useId } from "react";
import cx from "classnames";

import * as styles from "@/features/betslip/components/parts/PlaceMedal.module.scss";

type PlaceMedalProps = {
  place: number;
};

// Gold/silver/bronze for places 1-3; later places (First4) reuse silver.
const METAL_CLASSES = [styles.gold, styles.silver, styles.bronze];

export const PlaceMedal = ({ place }: PlaceMedalProps) => {
  const gradientId = useId();
  return (
    <span
      className={cx(styles.medal, METAL_CLASSES[place - 1] ?? styles.silver)}
      data-testid={`place-medal-${place}`}
    >
      <svg className={styles.ribbon} viewBox="0 0 24 24" aria-hidden="true">
        <defs>
          <linearGradient
            id={gradientId}
            x1="3.39"
            y1="6.24"
            x2="20.42"
            y2="23.27"
            gradientUnits="userSpaceOnUse"
          >
            <stop style={{ stopColor: "var(--medal-hi)" }} />
            <stop offset="0.4" style={{ stopColor: "var(--medal-mid)" }} />
            <stop offset="1" style={{ stopColor: "var(--medal-lo)" }} />
          </linearGradient>
        </defs>
        <path
          d="M2.19 17.5L0 19.69L3.02 20.92L4.25 23.94L6.45 21.74C4.67 20.75 3.19 19.28 2.19 17.5Z"
          fill={`url(#${gradientId})`}
        />
        <path
          d="M21.57 17.26C20.61 19.06 19.17 20.56 17.41 21.6L19.75 23.94L20.98 20.92L24 19.69L21.57 17.26Z"
          fill={`url(#${gradientId})`}
        />
      </svg>
      <span className={styles.body}>{place}</span>
    </span>
  );
};
